import React from 'react'
import { Grid } from '@mui/material'
import ColorBoxInfoVendor from 'common/Box/ColorBoxInforVendor'
import FormDetailsStack from 'common/Form/FormDetailsStack'
import TextColorFontHeader from 'common/Typography/TextColorFontHeader'

function CustomerDetailsBox() {
  const mockCustomerDetails = {
    contactName: 'Shawn',
    contactNumber: '91234567',
    deliveryAddress:
      'Delivery Address: Blk 123L Victoria Street, #12-123, S(123456)',
    deliverySlot: 'Preferred Delivery Slot: 2022-06-12, Wed, 12:00 - 13:00'
  }
  return (
    <ColorBoxInfoVendor>
      <TextColorFontHeader>Customer Details</TextColorFontHeader>
      <Grid container>
        <Grid item xs={6}>
          <FormDetailsStack
            formLabelHeader='Contact Name'
            formContent={mockCustomerDetails.contactName}
          />
        </Grid>
        <Grid item xs={6}>
          <FormDetailsStack
            formLabelHeader='Delivery Address'
            formContent={mockCustomerDetails.deliveryAddress}
          />
        </Grid>
      </Grid>
      <Grid
        container
        sx={{
          marginTop: '8px'
        }}
      >
        <Grid item xs={6}>
          <FormDetailsStack
            formLabelHeader='Contact Number'
            formContent={mockCustomerDetails.contactNumber}
          />
        </Grid>
        <Grid item xs={6}>
          <FormDetailsStack
            formLabelHeader='Delivery Slot'
            formContent={mockCustomerDetails.deliverySlot}
          />
        </Grid>
      </Grid>
    </ColorBoxInfoVendor>
  )
}

export default CustomerDetailsBox
